/**
 * This component intentionally left blank.
 */
export function AlphaForm() {
  return null;
}
